import { render, staticRenderFns } from "./Albaran.vue?vue&type=template&id=701bf646&scoped=true&"
import script from "./Albaran.vue?vue&type=script&lang=js&"
export * from "./Albaran.vue?vue&type=script&lang=js&"
import style0 from "./Albaran.vue?vue&type=style&index=0&id=701bf646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701bf646",
  null
  
)

export default component.exports